<div class="footer">
    <p>© {{getCurrentYear()}} - Prefeitura Municipal de Parnamirim</p>
    <div class="logos">
        <img src="assets/images/logo-prefeitura.svg" alt="imagem aqui">
        <div class="gcti">
            <span class="by">DESENVOLVIDO PELO</span>
            <span>
                <img src="assets/images/logo-gcti.svg" alt="outra imagem aqui">
            </span>
        </div>
    </div>
</div>
